import { IReactReaderStyle } from "react-reader";

export type ITheme = "dark" | "light";

export const ThemeConjunction = (styles: IReactReaderStyle, theme: ITheme) => {
    
    const themeMapping: {[key: string]: IReactReaderStyle} = {
        "dark": {
            ...styles,
            container: {
                ...styles.container,
                backgroundColor: 'rgba(26, 28, 30, 1)'
            },
            readerArea: {
                ...styles.readerArea,
                backgroundColor: 'rgba(26, 28, 30, 1)',
                transition: undefined,
            },
            titleArea: {
                ...styles.titleArea,
                color: '#ccc',
            },
            arrow: {
                ...styles.arrow,
                color: 'white',
            },
            arrowHover: {
                ...styles.arrowHover,
                color: '#ccc',
            },
            tocArea: {
                ...styles.tocArea,
                background: '#111',
            },
            tocButtonExpanded: {
                ...styles.tocButtonExpanded,
                background: '#222',
            },
            tocButtonBar: {
                ...styles.tocButtonBar,
                background: '#fff',
            },
            tocButton: {
                ...styles.tocButton,
                color: 'white',
            },
        },
        "light": {
            ...styles,
        }
    }

    return themeMapping[theme];
}